var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "19px",
    viewBox: "0 0 31 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TopHeader",
    transform: "translate(-913.000000, -15.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/",
    transform: "translate(913.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Arrowhead/down",
    transform: "translate(14.000000, 10.280767) rotate(30.000000) translate(-14.000000, -10.280767) ",
    points: "9 6 19 6 14 14.5615345"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 29.5,
    height: 16.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayer);
export default __webpack_public_path__ + "static/media/Player.a0d7596841e71a35f32090dc769915f0.svg";
export { ForwardRef as ReactComponent };